import SavedSignatures from './SavedSignatures';

export default SavedSignatures;